import { render, staticRenderFns } from "./PortalAdmin.vue?vue&type=template&id=5fefb943"
import script from "./PortalAdmin.vue?vue&type=script&lang=js"
export * from "./PortalAdmin.vue?vue&type=script&lang=js"
import style0 from "./PortalAdmin.vue?vue&type=style&index=0&id=5fefb943&prod&lang=css"
import style1 from "./PortalAdmin.vue?vue&type=style&index=1&id=5fefb943&prod&lang=css"
import style2 from "./PortalAdmin.vue?vue&type=style&index=2&id=5fefb943&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports